import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid';
import { ITEM_CLICK_EVENT } from '../../../search/search-constants';
import { SearchEvent } from '../../../search/models/search-event';

@Component({
  selector: 'lfwms-assign-lane-cell-renderer',
  templateUrl: './assign-lane-cell-renderer.component.html',
  styleUrls: ['./assign-lane-cell-renderer.component.css']
})
export class AssignLaneCellRendererComponent implements ICellRendererAngularComp {


  public params: any;
  public cellValue: any = [];
  public textColor;
  public templateId;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    if (params.colDef.colId === 'loadKey' || params.colDef.colId === 'mbolKey') {
      this.templateId = 2;
    }
  }


  public refresh(params: any): boolean {
    this.params = params;
    this.cellValue = this.params.value.cVal;
    return true;
  }

  /**
   * when a detail item is clicked we are emitting an event
   */
  public detailItemClicked(itemClicked: string) {
    const searchService = this.params.context.componentParent.searchService;
    const event = new SearchEvent(ITEM_CLICK_EVENT);
    event.selectedItemId = itemClicked;
    searchService.publishEvent(event);
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/assign-lane-popup/assign-lane-cell-renderer/assign-lane-cell-renderer.component.ts